export default {"src":"/_next/static/media/scalpel_40.e1eddf66.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};